import axios, { AxiosError } from 'axios';

import { studentGateway } from '../student-gateway';

import { ProgrammeBody } from '@types';

const requestedFields = [
    'id',
    'name',
    'user_id',
    'programme_type_reference',
    'onboarding_completed',
    'key_stage',
];

const requestedInclude = ['subject_directories'];
const fields = requestedFields.toString();
const include = requestedInclude.toString();

export const currentProgramme = async (): Promise<any | Error> => {
    try {
        const programme = await studentGateway.get('/programmes/current', {
            params: {
                fields,
                include,
            },
            withCredentials: true,
        });
        return programme.data;
    } catch (error) {
        if (axios.isAxiosError(error)) {
            const err = error as AxiosError;
            if (err.response && err.response.status === 404) {
                return null;
            } else {
                throw error;
            }
        }
    }
};

export const updateProgramme = async (
    requestBody: ProgrammeBody,
): Promise<any | Error> => {
    const programme = await studentGateway.put(
        '/programmes/current',
        {
            student_programme: requestBody,
        },
        {
            params: {
                fields,
                include,
            },
            withCredentials: true,
        },
    );

    return programme.data;
};
